
//路径白名单不受跳转限制
export const concatInfoList = [{
    label:"Phone",
    value:["(CN) +86 5118 0940"]
},{
    label:"Mobile",
    value:["+86 139 1616 7993"]
},{
    label:"E-mail",
    value:["nici@zs-cargo.com","csd@zs-cargo.com"]
},{
    label:"Address",
    value:["Room 2210-2211, No.1777 ZhongShan Road N, Putuo District, Shanghai, China 200061"]
}];

export const languageList = [{text: '简体中文', key: 'zh-CN'}, {text: 'English', key: 'en'}];


